import { render, staticRenderFns } from "./SectionTwo.vue?vue&type=template&id=5b60ad2f&scoped=true&"
import script from "./SectionTwo.vue?vue&type=script&lang=js&"
export * from "./SectionTwo.vue?vue&type=script&lang=js&"
import style0 from "./SectionTwo.vue?vue&type=style&index=0&id=5b60ad2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b60ad2f",
  null
  
)

export default component.exports